/** @file This file contains the error showing component for CodeGrade. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as utils from '@/utils';
/** The data used for the message slot. */
class ErrorMessageData {
    /** @param error The error the occurred. */
    constructor(error) {
        this.error = error;
        Object.freeze(this);
    }
    /** @returns The readable error message for the error that occurred. */
    get message() {
        return utils.getErrorMessage(this.error);
    }
}
/** The component to show an error. */
export default tsx.componentFactoryOf().create({
    name: 'cg-error',
    functional: true,
    props: {
        error: p(Error).required,
        variant: p.ofStringLiterals('danger', 'warning').default('danger'),
        wrappingComponent: p(String).default('b-alert'),
        doRetry: p.ofFunction().optional,
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(h, ctx) {
        const slotData = new ErrorMessageData(ctx.props.error);
        let content = utils
            .maybeRenderScopedSlot(slotData, ctx.scopedSlots.message)
            .orDefaultLazy(() => slotData.message);
        if (!IS_PRODUCTION) {
            content = [<div>{content}</div>, <pre class="mt-3">{ctx.props.error.stack}</pre>];
        }
        if (ctx.props.doRetry != null) {
            content = [
                <div>{content}</div>,
                <b-button-toolbar>
                    <b-button onClick={ctx.props.doRetry} variant="outline-danger" class="ml-auto">
                        Retry
                    </b-button>
                </b-button-toolbar>,
            ];
        }
        return h(ctx.props.wrappingComponent, {
            attrs: ctx.data.attrs,
            class: [ctx.data.class, ctx.data.staticClass, 'cg-error'],
            style: [ctx.data.style, ctx.data.staticStyle],
            props: {
                show: true,
                variant: ctx.props.variant,
            },
        }, [content]);
    },
});
